<template>

    <v-page-widget title="Unsubscribe Groups" actionTitle="Edit" :actionFunc="editUnsubGroups" :empty="!customer.unsub_groups.length">
        <template #body v-if="!customer.unsub_groups.length">
            <v-notice size="sm" message="No Unsubscribe Groups" />
        </template>
        <template #body v-else>
            <div class="mb--5">
                <v-tag v-for="group in customer.unsub_groups" :key="group.id">
                    <router-link :to="{ name: 'settings-unsub-groups-members', params: { id: group.id } }">{{ group.name }}</router-link>
                </v-tag>
            </div>
        </template>
    </v-page-widget>

</template>

<script>

export default {

    props: {
        customer: {
            type: Object,
            required: true,
        },
    },

    methods: {

        editUnsubGroups() {
            this.$router.push({ name: 'settings-unsub-groups' });
        },

    },

}

</script>
